import { Injectable } from '@angular/core';
import { StartupModel, ImageUploadUrl, StateModel, IndustryModel, SectorModel } from '../classes/model';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';

const httpOptions1 = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  }), responseType: 'text' as 'json'
};

@Injectable()
export class RdsServerService {

  constructor(private http: HttpClient) { }

  _url = 'https://ebnro45a9h.execute-api.ap-south-1.amazonaws.com/v2';

  //  ===============  POST STARTUP FORM  ====================
  postStartupForm(databody: StartupModel): Observable<StartupModel> {
    return this.http.post<StartupModel>(this._url + '/postStartup', databody, httpOptions1);
  }
  // ===============  SECTOR LOGO IMAGE UPLOAD  ====================
  getStartupLogoImageUrl(imageKey, extension): Observable<ImageUploadUrl> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.http.get<ImageUploadUrl>(this._url + '/getStartupLogos' + '?ImageKey=' + imageKey + '&extension=' + extension, httpOptions);
  }
  // ===============  SECTOR PITCH IMAGE UPLOAD  ====================
  getStartupPitchImageUrl(imageKey, extension): Observable<ImageUploadUrl> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    return this.http.get<ImageUploadUrl>(this._url + '/getStartupPitch' + '?ImageKey=' + imageKey + '&extension=' + extension, httpOptions);
  }

  getStateList(): Observable<StateModel> {
    return this.http.get<StateModel>(this._url + '/getStates');
  }

  getCityList(id): Observable<StateModel> {
    return this.http.get<StateModel>(this._url + '/getCities?id=' + id);
  }

  getIndustryList(): Observable<IndustryModel> {
    return this.http.get<IndustryModel>(this._url + '/getIndustry');
  }

  getSectorList(id): Observable<SectorModel> {
    return this.http.get<SectorModel>(this._url + '/getSectorList?id=' + id);
  }

  getAllSectorList(): Observable<SectorModel> {
    return this.http.get<SectorModel>(this._url + '/getAllSectorList');
  }

}
